import React, { Component, useState } from 'react';
import "./SignUp.css"
import MMCL_Logo from "../static/images/MMCL_Logo.webp";
import PasswordRegCheck from './custom_validations/PasswordRegCheck.js';
import { toast } from 'react-toastify';
import axios from '../api/axios.js';
import hideElements from '../utility/Tools.js';

var EnterKeyNotPressed=true

async function RegisterUser() {
    if(document.getElementById('passLength').style.color==="green"&& document.getElementById('passUpperAndLower').style.color==="green"&&
    document.getElementById('passLettersAndNumbers').style.color==="green"&&document.getElementById('passSpecialCharacters').style.color==="green" 
    && document.getElementById('passMatchPassword').style.color==="green"&&EnterKeyNotPressed){
    EnterKeyNotPressed=false;
    const Register_url="register/";
    let email = document.getElementById('inputEmail').value;
    let pwd = document.getElementById('inputPassword').value;
    const toastId = toast.loading('Creating Account'); 
      try {
          const response = await axios.post(Register_url, JSON.stringify({ email, pwd }),
              {
                  headers: { "Content-Type": "application/json" },
              }
          );
          if (response.status===200){
            toast.update(toastId, {
                render: 'Email already exist!',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            })   
            hideElements();
            document.getElementById('signUpHeader').innerText = "This email is already registered";
            document.getElementById('signUpText').innerText = "Please try signing-in instead.";
            document.getElementById('redirectSignIn').style.display = "block";
          }else{
          toast.update(toastId, {
              render: 'Congratulations! Your account has been successfully created.',
              type: 'success',
              isLoading: false,
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
          })
          hideElements();
          document.getElementById('signUpHeader').innerText = "Thank You For Signing Up!";
          document.getElementById('signUpText').innerText = "Please check your email for instructions on how to activate your account.";
          document.getElementById('redirectSignIn').style.display = "block";
        }
          //setSuccess(true);
          //Insert codes for clearing page or redirection
      } catch (err) {
        EnterKeyNotPressed=true;
          if (err.response.status === 409) { //Email already exist. Not working ATM
              //Error message
              toast.update(toastId, {
                  render: 'Email already exist!',
                  type: 'error',
                  isLoading: false,
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
              })
              hideElements();
              document.getElementById('signUpHeader').innerText = "This email is already registered";
              document.getElementById('signUpText').innerText = "Please try signing-in instead.";
              document.getElementById('redirectSignIn').style.display = "block";
          } else if (err.response?.status === 404) {//Email does not exist in salesforce
              toast.update(toastId, {
                  render: 'Email is not valid. Please submit your application first.',
                  type: 'warning',
                  isLoading: false,
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
              })  
          } else {
              toast.update(toastId, {
                  render: 'This e-mail address is not within our system.',
                  type: 'warning',
                  isLoading: false,
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
              })  
              //registration failed
          }
    }
}
}

export class SignUp extends Component {
    static displayName = SignUp.name;

componentDidMount(){
    document.getElementById("inputEmail").addEventListener("keypress", function(event){
        if(event.key==="Enter"){
            event.preventDefault();
            document.getElementById("btnRegister").click();
        }
    })
    document.getElementById("inputPassword").addEventListener("keypress", function(event){
        if(event.key==="Enter"){
            event.preventDefault();
            document.getElementById("btnRegister").click();
        }
    })
    document.getElementById("inputConfirmPassword").addEventListener("keypress",function(event){
        if(event.key==="Enter"){
            event.preventDefault();
            document.getElementById("btnRegister").click();
        }
    })
}

  render() {
    return (
        <div>
            <div className="sign-up">
                <div className="card sign-up-card">
                    <form>
                        <div className="sign-up-logo-container text-center">
                            <img src={MMCL_Logo} className="sign-up-logo" alt="MMCL Logo" />
                        </div>
                        <h3 id="signUpHeader" className="text-center mt-10 b-10">SIGN UP</h3>
                        <p id="signUpText" className="text-center"></p>
                        <div className="form-outline mb-4 hiding-elements">
                            <label className="form-label" for="inputEmail">Email address</label>
                            <input type="email" id="inputEmail" className="form-control" />
                            <p className="smaller fw-bold mt-2">Please use your registered email address for account activation.</p>
                        </div>
                        <div className="form-outline mb-4 hiding-elements">
                            <label className="form-label" for="inputPassword">Password</label>
                            <input type="password" id="inputPassword" className="form-control" onChange={PasswordRegCheck} />
                        </div>
                        <div className="form-outline mb-4 hiding-elements">
                            <label className="form-label" for="inputConfirmPassword">Confirm Password</label>
                            <input type="password" id="inputConfirmPassword" className="form-control" onChange={PasswordRegCheck}/>
                        </div>
                        <div id="passRequirements" style={{ display: "none" }} className="sign-up-pass-requirement hiding-elements">
                            <li id="passLength">✕ Password must be at least 8 characters.</li>
                            <li id="passUpperAndLower">✕ Password must be a combination of uppercase and lowercase letters.</li>
                            <li id="passLettersAndNumbers">✕ Password must be a combination of letters and numbers.</li>
                            <li id="passSpecialCharacters">✕ Password must have atleast one (1) special character (# ? ! + &).</li>
                            <li id="passMatchPassword">✕ Password must match.</li>   
                        <br/>
                        </div>
                        <div className="text-center hiding-elements">
                            <button id="btnRegister" type="button" className="btn btn-block mb-4 sign-up-button" onClick={() => RegisterUser()}>Sign up</button>
                        </div>
                        <div className="text-center hiding-elements">
                            <p>Already have an account? <a href="/sign-in" className="links sign-up-link">Sign In</a></p>
                        </div>
                        <div id="redirectSignIn" className="redirect-sign-in text-center hiding-elements">
                            <a href="/sign-in" className="links sign-up-link">← Go back to Sign in</a>
                        </div>
                    </form>
                </div>
            </div>
      </div>
    );
  }
}